export const homeAbout = [
  {
    id: 1,
    cover: "https://img.icons8.com/dotty/80/000000/storytelling.png",
    title: "Learning About Tech",
    desc: "We understand the market need, hence will keep you update with latest technologies in the market.",
  },
  {
    id: 1,
    cover: "https://img.icons8.com/ios/80/000000/diploma.png",
    title: "Career according to you",
    desc: "We will suggest you job as per your requirements.",
  },
  {
    id: 1,
    cover: "https://img.icons8.com/ios/80/000000/athlete.png",
    title: "Recruiter will reach you out",
    desc: "There are several HRs and recruiters that are looking for skilled candidates on Seekhobharat",
  },
];
export const awrapper = [
  {
    cover:
      "https://img.icons8.com/external-yogi-aprelliyanto-basic-outline-yogi-aprelliyanto/80/ffffff/external-graduation-education-yogi-aprelliyanto-basic-outline-yogi-aprelliyanto.png",
    data: "100000",
    title: "SUCCESS STORIES",
  },

  {
    cover: "https://img.icons8.com/ios/80/ffffff/athlete.png",
    data: "32000",
    title: "SKILLED PROFESSIONAL",
  },
  {
    cover:
      "https://img.icons8.com/external-outline-icons-maxicons/80/ffffff/external-calender-insurance-outline-outline-icons-maxicons.png",
    data: "10000",
    title: "INTERVIEWS",
  },
  {
    cover: "https://img.icons8.com/ios/80/ffffff/macbook-idea--v3.png",
    data: "20",
    title: "Technologies",
  },
];
export const coursesCard = [
  {
    id: 1,
    cover: "../images/courses/c1.png",
    coursesName: "Full Stack Developer",
    courTeacher: [
      {
        dcover: "coding.png",
      },
    ],
    priceAll: "100000 people are looking for this role.",
    pricePer: "700000 avg salary",
  },
  {
    id: 2,
    cover: "growth.png",
    coursesName: "Product Engineer",
    courTeacher: [
      {
        dcover: "growth.png",
      },
    ],
    priceAll: "10000 people are looking for this role",
    pricePer: "600000 avg salary",
  },
  {
    id: 3,
    cover: "../images/courses/c3.png",
    coursesName: "Data Analyst",
    courTeacher: [
      {
        dcover: "coding.png",
      },
    ],
    priceAll: "23000 people are looking for this role",
    pricePer: "500000 avg salary",
  },
  {
    id: 4,
    cover: "../images/courses/c4.png",
    coursesName: "Introducing to Programming with WordPress",
    courTeacher: [
      {
        dcover: "./images/back.webp",
        name: "by Prabin Thapa Mager",
        totalTime: "20 lectures (20 hrs)",
      },
    ],
    priceAll: "$30 All Course",
    pricePer: "$3 per month",
  },
  {
    id: 5,
    cover: "../images/courses/c5.png",
    coursesName: "Introducing to Programming with ReactJS",
    courTeacher: [
      {
        dcover: "./images/back.webp",
        name: "by Sunil Bishowkaram",
        totalTime: "100 lectures (150 hrs)",
      },
    ],
    priceAll: "$300 All Course",
    pricePer: "$30 per month",
  },
  {
    id: 6,
    cover: "../images/courses/c6.png",
    coursesName: "Learn Frontend Programming Language",
    courTeacher: [
      {
        dcover: "./images/back.webp",
        name: "by Sunil Bishowkaram",
        totalTime: "200 lectures (300 hrs)",
      },
    ],
    priceAll: "$500 All Course",
    pricePer: "$80 per month",
  },
  {
    id: 7,
    cover: "../images/courses/c7.png",
    coursesName: "Introducing to with HTML / CSS",
    courTeacher: [
      {
        dcover: "./images/back.webp",
        name: "by Price",
        totalTime: "20 lectures (50 hrs)",
      },
    ],
    priceAll: "$20 All Course",
    pricePer: "$2 per month",
  },
  {
    id: 8,
    cover: "../images/courses/c8.png",
    coursesName: "Introducing to with JAVA",
    courTeacher: [
      {
        dcover: "./images/back.webp",
        name: "by Petter",
        totalTime: "80 lectures (200 hrs)",
      },
    ],
    priceAll: "$200 All Course",
    pricePer: "$40 per month",
  },
  {
    id: 9,
    cover: "../images/courses/c9.png",
    coursesName: "Introducing to with HTML / CSS / JAVASCRIPT",
    courTeacher: [
      {
        dcover: "./images/back.webp",
        name: "by Petter",
        totalTime: "50 lectures (50 hrs)",
      },
    ],
    priceAll: "$20 All Course",
    pricePer: "$3 per month",
  },
];
export const online = [
  {
    cover: "./images/courses/online/o1.png",
    hoverCover: "./images/courses/online/o1.1.png",
    courseName: "UI/UX Design Courses",
    course: "25000 jobs",
  },
  {
    cover: "./images/courses/online/o2.png",
    hoverCover: "./images/courses/online/o2.1.png",
    courseName: "Art & Design",
    course: "12000 jobs",
  },
  {
    cover: "./images/courses/online/o3.png",
    hoverCover: "./images/courses/online/o3.1.png",
    courseName: "Computer Science",
    course: "200000 jobs",
  },
  {
    cover: "./images/courses/online/o4.png",
    hoverCover: "./images/courses/online/o4.1.png",
    courseName: "History & Archeologic",
    course: "22000 jobs",
  },
  {
    cover: "./images/courses/online/o5.png",
    hoverCover: "./images/courses/online/o5.1.png",
    courseName: "Software Engineering",
    course: "340000 jobs",
  },
  {
    cover: "./images/courses/online/o6.png",
    hoverCover: "./images/courses/online/o6.1.png",
    courseName: "Information Software",
    course: "120000 jobs",
  },
  {
    cover: "./images/courses/online/o7.png",
    hoverCover: "./images/courses/online/o7.1.png",
    courseName: "Health & Fitness",
    course: "400000 jobs",
  },
  {
    cover: "./images/courses/online/o8.png",
    hoverCover: "./images/courses/online/o8.1.png",
    courseName: "Marketing",
    course: "390000 jobs",
  },
  {
    cover: "./images/courses/online/o9.png",
    hoverCover: "./images/courses/online/o9.1.png",
    courseName: "Graphic Design",
    course: "90000 jobs",
  },
  {
    cover: "./images/courses/online/o10.png",
    hoverCover: "./images/courses/online/o10.1.png",
    courseName: "Music",
    course: "20000 jobs",
  },
  {
    cover: "./images/courses/online/o11.png",
    hoverCover: "./images/courses/online/o11.1.png",
    courseName: "Business Administration",
    course: "400000 jobs",
  },
  {
    cover: "./images/courses/online/o12.png",
    hoverCover: "./images/courses/online/o12.1.png",
    courseName: "Web Management",
    course: "40000 jobs",
  },
];
export const team = [
  {
    cover: "airbnb.png",
    name: "Airbnb",
    work: "DEVELOPER AND LEAD INSTRUCTOR",
  },
  {
    cover: "./images/team/t2.webp",
    name: "Ph.D Arthur MaGregor",
    work: "DEVELOPER AND LEAD INSTRUCTOR",
  },
  {
    cover: "./images/team/t3.webp",
    name: "Ph.D Anna Hanzen",
    work: "DEVELOPER AND LEAD INSTRUCTOR",
  },
  {
    cover: "./images/team/t4.webp",
    name: "Ph.D Brian Wooden",
    work: "DEVELOPER AND LEAD INSTRUCTOR",
  },
  {
    cover: "./images/team/t5.webp",
    name: "Ph.D Adrian Molises",
    work: "DEVELOPER AND LEAD INSTRUCTOR",
  },
  {
    cover: "./images/team/t6.webp",
    name: "Ph.D Arthur MaGregor",
    work: "DEVELOPER AND LEAD INSTRUCTOR",
  },
  {
    cover: "./images/team/t7.webp",
    name: "Ph.D Anna Hanzen",
    work: "DEVELOPER AND LEAD INSTRUCTOR",
  },
  {
    cover: "./images/team/t8.webp",
    name: "Ph.D Brian Wooden",
    work: "DEVELOPER AND LEAD INSTRUCTOR",
  },
];
export const job = [
  {
    name: "Full Stack Development",
    job: "9 lakhs",
    desc: "Embark on a comprehensive journey in Full Stack Development with Seekho Bharat. Whether you're passionate about crafting seamless user experiences or delving into server-side logic, our platform connects you with opportunities to master both front-end and back-end technologies. ",
  },
  {
    name: "Cloud Engineering",
    job: "7 lakhs",
    desc: "Elevate your career to new heights with Seekho Bharat's Cloud Engineering opportunities. Dive into the world of scalable and resilient cloud architectures, working with leading cloud platforms.",
  },
  {
    name: "Data Science",
    job: "10 lakhs",
    desc: "Unleash the power of data with Seekho Bharat's Data Science careers. Whether you're passionate about extracting insights, building predictive models, or creating data-driven solutions, our platform connects you with opportunities at the forefront of the data science revolution.",
  },
  {
    name: "Product Management",
    job: "16 lakhs",
    desc: "Enter the dynamic world of Product Management with Seekho Bharat. As a product manager, you play a pivotal role in shaping the success of a product from ideation to market launch. Our platform connects you with opportunities to lead cross-functional teams, define product strategies, and drive innovation.",
  },
];
export const faq = [
  {
    title: "How to Enroll This Online Courses?",
    desc: "This is the first item's accordion body. It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. It's also worth noting that just about any HTML can go within the .accordion-body, though the transition does limit overflow.",
  },
  {
    title: "Where It is hidden by default, until the collapse?",
    desc: "It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. It's also worth noting that just about any HTML can go within the .accordion-body, though the transition does limit overflow.",
  },
  {
    title: "How It is hidden by default, until the collapse?",
    desc: "It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. It's also worth noting that just about any HTML can go within the .accordion-body, though the transition does limit overflow.",
  },
  {
    title: "How to Enroll This Online Courses?",
    desc: "This is the first item's accordion body. It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. It's also worth noting that just about any HTML can go within the .accordion-body, though the transition does limit overflow.",
  },
  {
    title: "Where It is hidden by default, until the collapse?",
    desc: "It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. It's also worth noting that just about any HTML can go within the .accordion-body, though the transition does limit overflow.",
  },
  {
    title: "How It is hidden by default, until the collapse?",
    desc: "It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. It's also worth noting that just about any HTML can go within the .accordion-body, though the transition does limit overflow.",
  },
];
export const blog = [
  {
    id: 1,
    type: "admin",
    date: "JAN. 18, 2021",
    com: "3 COMMENTS ",
    title: "Build your Dream Software & Engineering Career",
    desc: "Elevate your career in the dynamic realm of Software Engineering with Seekho Bharat. Explore opportunities to work on cutting-edge technologies and groundbreaking projects that shape the digital landscape.",
    cover: "../images/blog/b1.webp",
  },
  {
    id: 2,
    type: "admin",
    date: "API. 25, 2022",
    com: "5 COMMENTS ",
    title: "Build your Dream Product Engineering Career",
    desc: "Dive into the realm of Product Engineering with Seekho Bharat. Unleash your creativity and technical prowess as you collaborate with industry leaders to build innovative products that make a lasting impact. Our platform connects aspiring engineers. ",
    cover: "../images/blog/b2.webp",
  },
  {
    id: 3,
    type: "user",
    date: "MAY. 15, 2022",
    com: "10 COMMENTS ",
    title: "Build your Dream Data Analytics Career",
    desc: "Unlock the power of data with Seekho Bharat's Data Analytics opportunities. Whether you're a data enthusiast, analyst, or scientist, our platform connects you with companies at the forefront of leveraging data for insights and decision-making.",
    cover: "../images/blog/b3.webp",
  },
  {
    id: 4,
    type: "admin",
    date: "JAN. 02, 2022",
    com: "3 COMMENTS ",
    title: "Build your Dream Data Analytics Career",
    desc: "A small river named Duden flows by their place and supplies it with the necessary regelialia.",
    cover: "../images/blog/b4.webp",
  },
  {
    id: 5,
    type: "admin",
    date: "DEC. 14, 2022",
    com: "3 COMMENTS ",
    title: "Build your Dream Software & Engineering Career",
    desc: "A small river named Duden flows by their place and supplies it with the necessary regelialia.",
    cover: "../images/blog/b5.webp",
  },
  {
    id: 6,
    type: "user",
    date: "JAN. 18, 2021",
    com: "12 COMMENTS ",
    title: "Build your Dream Software & Engineering Career",
    desc: "A small river named Duden flows by their place and supplies it with the necessary regelialia.",
    cover: "../images/blog/b6.webp",
  },
];

export const tech = [
  {
    title: "Fullstack Development",
    desc: "Elevate your career in the dynamic realm of Full stack development with Seekho Bharat. Explore opportunities to work on cutting-edge technologies and groundbreaking projects that shape the digital landscape.",
    cover: "fullstack.png",
  },
  {
    title: "Cloud Engineering",
    desc: "Dive into the realm of Cloud Engineering with Seekho Bharat. Unleash your creativity and technical prowess as you collaborate with industry leaders to build innovative products that make a lasting impact. Our platform connects aspiring engineers. ",
    cover: "cloud.png",
  },
  {
    title: "Data Science",
    desc: "Unlock the power of data with Seekho Bharat's Data Science opportunities. Whether you're a data enthusiast, analyst, or scientist, our platform connects you with companies at the forefront of leveraging data for insights and decision-making.",
    cover: "ds.png",
  },
  {
    title: "Business Management",
    desc: "Elevate your career in the dynamic realm of Management with Seekho Bharat. Explore opportunities to work on cutting-edge technologies and groundbreaking projects that shape the digital landscape.",
    cover: "bm.jpeg",
  },
  {
    title: "UI/UX Designer",
    desc: "Dive into the realm of designing with Seekho Bharat. Unleash your creativity and technical prowess as you collaborate with industry leaders to build innovative products that make a lasting impact. Our platform connects aspiring engineers. ",
    cover: "ui.jpeg",
  },
  {
    title: "AI&ML",
    desc: "Unlock the power of AI with Seekho Bharat's AIML opportunities. Whether you're a data enthusiast, AI enthusiast our platform connects you with companies at the forefront of leveraging data for insights and decision-making.",
    cover: "aiml.jpeg",
  },
];

export const testimonal = [
  {
    id: 1,
    name: "Airbnb",
    post: "Vacation & stay",
    desc: "In our pursuit of educational excellence, Seekho Bharat is privileged to have Airbnb as one of our distinguished partners. Collaborating with Airbnb, a global innovator in the hospitality industry, we strive to provide students with a unique learning experience.",
    cover: "airbnb_logo.png",
  },
  {
    id: 2,
    name: "American express",
    post: "Bank",
    desc: "Seekho Bharat takes pride in its collaboration with American Express, a trailblazer in the financial services sector. Our partnership is founded on a shared commitment to preparing students for success in the dynamic world of finance and business. ",
    cover: "amex.png",
  },
  {
    id: 3,
    name: "Deloitte",
    post: "Finance & Audit",
    desc: "At Seekho Bharat, we are honored to partner with Deloitte, a global leader in professional services. Our collaboration with Deloitte is grounded in a shared vision of fostering talent and cultivating the next generation of industry leaders. ",
    cover: "deloitte.png",
  },
];
